// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"fries"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M5.50066 18.5004L9.00066 22.0004L19 16L8 5L2.00066 15.0004L5.50066 18.5004Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M15.3437 4.52975L13.2224 2.40843L9.31544 6.31544L17.8007 14.8007L21.0006 11.6008L18.8793 9.4795L21.0006 7.35818L18.8793 5.23686L19.5864 4.52975L17.4651 2.40843L15.3437 4.52975Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M11.4368 8.43675L9.31544 6.31543L13.2224 2.40843L15.3437 4.52975L11.4368 8.43675ZM11.4368 8.43675L13.5581 10.5581M11.4368 8.43675L17.4651 2.40843L19.5864 4.52975L13.5581 10.5581M13.5581 10.5581L15.6794 12.6794M13.5581 10.5581L18.8793 5.23686L21.0006 7.35818L15.6794 12.6794M15.6794 12.6794L17.8007 14.8007L21.0006 11.6008L18.8793 9.4795L15.6794 12.6794Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5.00032 10L14.0003 19M9.00098 22.0004L19.0003 16L8.00032 5L2.00098 15.0004L9.00098 22.0004Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-fries')
export default class FriesIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'fries',
    }
  }
}
